import {post} from '../shoptools/fetch';
import {updateFavourites, sessionKey} from '../shoptools/index';
import $ from "jquery"; // TODO purge

export function favouriteAdd (form) {
  const html = document.documentElement;
  const $form = $(form);

  // submit form
  const submit = () => {
    const url = form.getAttribute('action');
    const data = $form.serialize();

    post(url, data).then((response) => {
      return response.json();
    }).then((data) => {
      if (data.success) {
        updateFavourites(data.favourites);
        window.sessionStorage.removeItem(sessionKey);
        form.classList.add('added');
        form.classList.remove('error');
      } else {
        // handle error
        form.querySelector('.error').innerHTML = data.errors;
        form.classList.add('error');
      }
    });
  };
  // bind keyup listener
  form.addEventListener('submit', (e) => {
    e.preventDefault();
    if (html.classList.contains('state-logged-in')) {
      // logged in
      submit();
    } else {
      // not logged in
      form.classList.add('login');
    }
  });
}


export function favouriteRemove (form) {
  const $form = $(form);

  // submit form
  const submit = () => {
    const url = form.getAttribute('action');
    const data = $form.serialize();

    post(url, data).then((response) => {
      return response.json();
    }).then((data) => {
      if (data.success) {
        updateFavourites(data.favourites);
        window.sessionStorage.removeItem(sessionKey);
      } else {
        // handle error
        form.querySelector('.error').innerHTML = data.errors;
        form.classList.add('error');
      }
    });
  };
  // bind keyup listener
  form.addEventListener('submit', (e) => {
    e.preventDefault();
    submit();
  });
}



// WEBPACK FOOTER //
// ./assets/j/shoptools/favourites.js